import React, { Component } from 'react';
import { AiOutlineCaretRight } from 'react-icons/ai';
import image from '../assets/img/main.png';

import loadable from '@loadable/component'
// const image = loadable(() => import('../assets/img/main.png'))

class AboutUs extends Component {

    render() {
        return (
            <div className="">
                <img className='w-100 h-auto' src={image} alt="" />
                {/* <div className="w-100 height-70-vh overflow-hidden bg-image-about-us ">

                </div> */}
                <div className=" relative test-parent">
                    {/* <div className=" para-test"></div> */}
                    <div className='bg-white relative test height-50-vh absolute z-0 blank-space'></div>
                    <div className=" test lines line-first"></div>
                    <div className=' test bg-orange lines middle'></div>
                    <div className=" test lines line-last"></div>

                    {/* <div className=" pas-test"> </div> */}
                </div>
                <div className="w-90 about-us-main-text relative left-5 height-80-vh z-index-front flex vertical-flex flex-space-around mt-5-vh z-5">
                    <div className="w-60">
                        <h3 className="blue m-0">Kush jemi ne?</h3>
                        <p className=" m-0">Ne jemi Website që ofron mundësi për shpallje/gjetjen e të gjitha patundshmërive të ndryshme veturave me qera apo shitje,</p>
                        <p className=" m-0">po ashtu për të gjetur të gjitha llojet e gastronomis!</p>
                        <br/>
                        <p className=" m-0">Ne nuk jemi agjent dhe nuk shesim/lëshojmë me qera banesa/shtëpi, ne jemi ndërmjetësues.</p>
                        <p className=" m-0">Ndërmjetësues mes shitësit dhe blerësit, qiradhënësit dhe qiramarrësit, po ashtu dhe shitësit me agjent, qiradhënësit me agjent!</p>
                        <br/>
                        <p className=" m-0">Ne ofrojmë publikimin e shitjeve dhe lëshimin me qera të veturave.</p>
                        <p className=" m-0">Po ashtu ofrojmë shpalljen/gjetjen e restoranteve dhe bareve të ndryshme.</p>
                    </div>
                    <div>
                        <h3 className="blue m-0">Çka ofrojmë ne ? </h3>
                        <ul className="no-decorations no-bulletpoints p-0">
                            <li className=""><AiOutlineCaretRight className="blue mr-20-px" /><i>Banesa\shtëpi me qera</i></li>
                            <li className=""><AiOutlineCaretRight className="blue mr-20-px" /><i>Banesa\shtëpi në shitje</i></li>
                            <li className=""><AiOutlineCaretRight className="blue mr-20-px" /><i>Vetura me qera</i></li>
                            <li className=""><AiOutlineCaretRight className="blue mr-20-px" /><i>Vetura ne shitje</i></li>
                            <li className=""><AiOutlineCaretRight className="blue mr-20-px" /><i>Gastronomi</i></li>
                            <li className=""><AiOutlineCaretRight className="blue mr-20-px" /><i>Restaurante dhe bare te ndryshme</i></li>
                        </ul>
                        <h3 className="blue m-0">Të shpallura nga:</h3>
                        <ul className="no-decorations no-bulletpoints p-0">
                            <li className=""><AiOutlineCaretRight className="blue mr-20-px" /><i>Pronar apo agjent i patundshmeris</i></li>
                            <li className=""><AiOutlineCaretRight className="blue mr-20-px" /><i>Restorant</i></li>
                            <li className=""><AiOutlineCaretRight className="blue mr-20-px" /><i>Rent a car apo Auto sallon</i></li>
                        </ul>
                    </div>
                    {/* <div className="w-60">
                        <h3 className="blue m-0">Kush mund të bëj shpërndarje (postim) të banesës apo shtëpisë?</h3>
                        <p>Jo vetëm agjentët e patundshmërisë por të gjithë ju që i ofroni këto shërbime. Dhe po ashtu të gjitha shpërndarjet do te jenë pa pagesë.</p>
                    </div> */}
                    <div className="w-60">
                        <h3 className="blue m-0">Cili është qëllimi jonë?</h3>
                        <p>Të ju ofrojmë zgjidhje më të shpejtë dhe më të lehtë për blerjen apo shitjen që do e bëni ashtu siç e dëshironi dhe aty ku e dëshironi.</p>
                    </div>

                    <h3> <a className="blue" href="https://www.kulmi-ks.com">www.kulmi-ks.com </a></h3>

                    <span className='m-0'> Faqja u dizajnua nga Adonis Rexha, Logo nga Fatos Rexhepi dhe u zhvillua nga Arbër Kadriu</span>
                </div>
            </div>
        );
    }
}

export default AboutUs;